import { css } from '@emotion/react';

export const footerStyles = css`
  width: 100%;
  background-color: var(--surface-neutral);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-6);
  padding: var(--spacing-12) 0;
`;

export const footerSectionStyles = css`
  width: 100%;
  padding-left: var(--spacing-4);
  padding-right: var(--spacing-4);
`;

export const footerTopSectionStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-8);
  width: 100%;
`;

export const footerBrandStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-6);
  width: 100%;
`;

export const footerLogoStyles = css`
  display: block;
  max-height: 35px;
  max-width: 200px;
  width: 100%;
  height: auto;
`;

export const footerLinksRowStyles = css`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;

export const footerLinkColumnStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
  flex: 1;
  min-width: 0;
  max-width: 172px;
`;

export const footerLinkGroupStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const footerLinkStyles = css`
  color: var(--text-primary);
  white-space: nowrap;

  &:hover {
    color: var(--text-action-hover);
  }
`;

export const footerBottomSectionStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-8);
  width: 100%;
`;

export const footerBottomContentStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-6);
  width: 100%;
`;

export const footerSocialLinksStyles = css`
  display: flex;
  align-items: center;
  gap: var(--spacing-6);
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const footerSocialLinkStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-primary);
  text-decoration: none;

  &:hover {
    color: var(--text-action-hover);
  }

  &:focus-visible {
    outline: 2px solid var(--border-focus);
    outline-offset: 2px;
  }
`;

export const footerSocialIconStyles = css`
  width: 24px;
  height: 24px;
`;
